/**
 * API Configuration
 * Automatically detects the correct backend URL based on the environment
 */

const getBackendUrl = () => {
  // If REACT_APP_BACKEND_URL is set and valid, use it
  if (process.env.REACT_APP_BACKEND_URL) {
    const url = process.env.REACT_APP_BACKEND_URL;
    // Check if it's not an old preview URL
    if (!url.includes('emergent.host') || url.includes(window.location.hostname)) {
      return url;
    }
  }
  
  // For production on nishikigoi.fr, use relative URL (same domain)
  if (window.location.hostname === 'nishikigoi.fr' || 
      window.location.hostname === 'www.nishikigoi.fr') {
    return '';  // Empty string = relative URL = same domain
  }
  
  // For preview environments on emergentagent.com
  if (window.location.hostname.includes('emergentagent.com')) {
    return window.location.origin;
  }
  
  // Fallback to env variable or current origin
  return process.env.REACT_APP_BACKEND_URL || window.location.origin;
};

export const API_BASE_URL = getBackendUrl();
export const API = `${API_BASE_URL}/api`;

export default API;
